// @flow
import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {AvailabilityState} from 'redux/uiState/availability/AvailabilityState';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  HIDE_AVAILABILITY_OVERLAY,
  SHOW_AVAILABILITY_OVERLAY,
} from 'redux/uiState/availability/actions';
import {availabilityState} from 'redux/uiState/UiState';

const initState: AvailabilityState = {
  overlayShown: false,
};

const actionCreators: ActionHandlers<AvailabilityState> = {
  [PURE(SHOW_AVAILABILITY_OVERLAY)]: (state: AvailabilityState) => ({
    ...state,
    overlayShown: true,
  }),
  [PURE(HIDE_AVAILABILITY_OVERLAY)]: (state: AvailabilityState) => ({
    ...state,
    overlayShown: false,
  }),
};

export const availabilityReducer: Reducer<AvailabilityState> = // $FlowIgnore
  createReducerUsingActionHandlers<AvailabilityState>(
    initState,
    actionCreators
  );

export const getOverlayShown: Selector<boolean> = createSelector(
  availabilityState,
  (state: AvailabilityState) => state.overlayShown
);
